import { render, staticRenderFns } from "./OrderDetailsTab.vue?vue&type=template&id=00e3da38&scoped=true&"
import script from "./OrderDetailsTab.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsTab.vue?vue&type=style&index=0&id=00e3da38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3da38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
